module.exports = __webpack_public_path__ + "img/5-onebg.26978208.png";